<template>
    <div class="block-vido container margin-both-lg">
        <div v-observe-visibility="visibilityChanged" class="inner" :class="{'video-is-playing' : videoIsPlaying}">
            <div class="inner-elements">
                <button class="playButton" @click="playPauseVideo()" v-html="displayPlayButton()"></button>
                <h2 v-if="data.title" class="titler">{{data.title}}</h2>
                <p v-if="data.description" class="description">{{data.description}}</p>
            </div>
            <div class="overlay"></div>
            <WpImage                 
                v-if="data.video_placeholder" 
                :image="data.video_placeholder"
                size="large"
                class="image_bg_video"
                background 
                cover
                />
            <div ref="videoPlayer" class="video-player" v-html="data.video">
            </div>
        </div>
        
    </div>
</template>

<script>

import { play } from '@/components/../icons';
import WpImage from '@/components/elements/WpImage'

export default {
    name: 'vide-module',
    props: ['data'],
    data(){
        return {
            videoIsPlaying: false,
            apiInit: false,
            YTPlayer: null,
        }
    },
    mounted(){
        const VM = this;
        if (typeof(YT) == 'undefined' || typeof(YT.Player) == 'undefined') {
            var tag = document.createElement('script');
            tag.src = "https://www.youtube.com/iframe_api";
            var firstScriptTag = document.getElementsByTagName('script')[0];
            firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

            window.onYouTubePlayerAPIReady = function() {
                VM.initPlayer();
            };
        } else {
            VM.initPlayer();
        }
        
    },
    computed:{
        
    },
    destroyed(){
       
    },
    components:{
        WpImage
    },
    methods:{
        initPlayer(){
            const element = this.$refs.videoPlayer;
            if(element){
                const src = window.$(element).find('iframe')[0].src 
                if(src.includes('https')){
                    window.$(element).find('iframe')[0].src  = src + '&enablejsapi=1'
                    this.initYoutubePlayers()
                }
            }
        },
        displayPlayButton(){
            return play('#fff');
        },
        playPauseVideo(){
            if(this.apiInit){
                if(this.YTPlayer){
                    if(this.videoIsPlaying){
                        this.videoIsPlaying = false
                        this.stopVideo()
                    }else{
                        this.videoIsPlaying = true
                        this.playVideo()
                    }
                }
            }
            
            
        },
        stopVideo() {
            this.YTPlayer.stopVideo();
        },
        playVideo() {
            this.YTPlayer.playVideo();
        },
        onPlayerStateChange(event){
            if(event.data === 0){
                //video ended, trigger stop action
                this.playPauseVideo()
            }
            if(event.data === 1){
                //video is playing, (Maybe user click on iframe itself, so handle it)
                this.videoIsPlaying = true
            }
            if(event.data === 2){
                //video paused
                this.videoIsPlaying = false
            }
        },
        onPlayerError(){
            this.videoIsPlaying = false
            //console.log("YouTube Error");
        },
        onPlayerReady(){
            this.apiInit = true;
        },
        initYoutubePlayers(){
            const VM = this;
            const element = this.$refs.videoPlayer;
            if(!element) return false;
            const ytiframe = window.$(element).find('iframe')[0]

            this.YTPlayer = new YT.Player(ytiframe, {
                playerVars: { 
                    'autoplay': 0,
                    'controls': 0, 
                    'rel' : 0,
                    'fs' : 0,
                },
                events: {
                    onStateChange: VM.onPlayerStateChange,
                    onError: VM.onPlayerError,
                    onReady: VM.onPlayerReady
                }
            });
        },
        visibilityChanged (isVisible) {
            if(!isVisible && this.videoIsPlaying){
                this.playPauseVideo()
            }
        }
    }
};
</script>

<style lang="scss">
@import "@/assets/vars.scss";
@import "@/assets/mixins.scss";

.module-video_block{
    position: relative;

    .image_bg_video{
        z-index: 5;
    }
    .inner{
        padding-bottom: 56.4%;
        height: 0;
        position: relative;
        border-radius: $blocksRadius;
        overflow: hidden;
        &.video-is-playing{
            .image_bg_video, .inner-elements, .overlay{
                opacity: 0;
                visibility: hidden;
            }
        }
    }
    .image_bg_video, .inner-elements, .overlay{
        transition: visibility 0.2s ease-in-out, opacity 0.2s ease-in-out;
        will-change: opacity, visibility;
    }
    .image_bg_video, .video-player, .image_bg_video, .video-player iframe{
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;  
        
    }
    .video-player{
        iframe{
            width: 100%;
            height: 100%;
        }
    }
    .overlay{
        background-image: linear-gradient(180deg, rgba(0,52,77,0.00) 0%, #00344D 100%);
        position: absolute;
        top: 50%;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 8;
        border-radius: $blocksRadius;
    }
    .inner-elements{
        max-width: 700px;
        padding-left: 15px;
        padding-right: 15px;
        margin-left: auto;
        margin-right: auto;
        color: #fff;
        z-index: 10;
        position: relative;
        text-align: center;
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        .titler{
            @include fluid-type($smallResText, $wideResText, 16px, 25px);
            @include mquery($tablet){
                margin-top: 20px;
            }

        }
        .description{
            @include fluid-type($smallResText, $wideResText, 11px, 18px);
        }
    }
    .wp-image-vue .image{
        border-radius: $blocksRadius;
        overflow: hidden; 
    }
    .playButton{
        box-shadow: none;
        border: none;
        background-color: transparent;
        cursor: pointer;
        svg{
            width: 50px;
            height: 50px;
            circle{
                fill: $yellow
            }
            @include mquery($tablet){
                width: 40px;
                height: 40px; 
            }
            @include mquery($phone){
                width: 35px;
                height: 35px; 
            }
        }
    }
}
</style>
